import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useFetchBusinessService } from './api/useFetchBusinessService';
import { SetupBusinessServiceForm } from './SetupBusinessServiceForm';
import { GlobalService } from './types';

interface SetupBusinessServicesProps {
  addOn: {
    id: string;
    name: string;
    accountType: string;
    dateActive: string;
    dateInactive: string;
  };
  businessId: number;
  globalService?: GlobalService;
  onCancel: () => void;
  onSuccess: (message: { title: string; message: string }) => void;
}

const queryClient = new QueryClient(); // move to global area when we convert over more MFEs

export const SetupBusinessServices = (props: SetupBusinessServicesProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SetupBusinessServicesContent {...props} />
    </QueryClientProvider>
  );
};

const SetupBusinessServicesContent = ({
  addOn,
  businessId,
  globalService,
  onCancel,
  onSuccess,
}: SetupBusinessServicesProps) => {
  const { data: businessService } = useFetchBusinessService({
    addOnId: addOn.id,
  });

  return (
    <SetupBusinessServiceForm
      addOn={addOn}
      businessService={businessService}
      businessId={businessId}
      globalService={globalService}
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
};
